module.exports = __webpack_public_path__ + "static/hero-blacksmith-7956737dccd1d56ff40465101aef6b78.jpg";